import React from 'react';
import App from '../../../models/app';

export enum LabelName {
  CANNOT_INSTALL = 'CANNOT_INSTALL',
  CANNOT_INSTALL_NO_VERSION_AVAILABLE = 'CANNOT_INSTALL_NO_VERSION_AVAILABLE',
  CANNOT_INSTALL_REGION_VERSION = 'CANNOT_INSTALL_REGION_VERSION',
  COMPATIBILITY = 'COMPATIBILITY',
  PAID = 'PAID',
}

export interface LabelTexts {
  key: string;
  title: string;
  message: string;
  link?: string;
}

export interface LabelType {
  shouldDisplay: (app: App) => boolean;
  translationKey: (app: App) => string;
  labelKey?: (texts: LabelTexts) => string;
  labelTitle?: (texts: LabelTexts) => string;
  labelMessage?: (texts: LabelTexts, app: App, options: { phoneAppVersion: string, deviceName: string }) => React.ReactNode | string;
  name: LabelName;
}

// FilterType sets the entry names for filters in translations file.
// These values are also used in i18n for key 'page.Collection.Filters.'.
export enum FilterType {
  FREE = 'FREE',
  PAID = 'PAID',
  // TODO For future use.
  // PREMIUM = 'PREMIUM'
}
